import React from 'react';
import { connect } from 'react-redux';
import { Route, Switch, Redirect } from 'react-router-dom';
import { ConnectedRouter } from 'react-router-redux';
import asyncComponent from './components/wrappers/async-component';
import AuthenticatedRoute from './components/wrappers/auth-route';
import {
  createEmptyBooklet,
  fetchBooklet,
  setLazyLoading,
  fetchBookletShared,
} from './reducers/booklet.reducer';
import { fetchBookletList } from './reducers/booklet-list.reducer';
import {
  fetchUsers,
  createEmptyUser,
  fetchUser,
} from './reducers/users.reducer';
import { fetchBookletArchive } from './reducers/booklet-archive.reducer';
import {
  fetchExtension,
  createEmptyExtension,
} from './reducers/extension.reducer';
import { fetchFolders } from './reducers/folder.reducer';

const AsyncBookletList = asyncComponent(() =>
  import('./components/booklet-list/booklet-list')
);
const AsyncBookletArchive = asyncComponent(() =>
  import('./components/booklet-archive/booklet-archive')
);
const AsyncBooklet = asyncComponent(() =>
  import('./components/booklet/booklet')
);
const AsyncBookletShared = asyncComponent(() =>
  import('./components/booklet-shared/booklet-shared')
);
const AsyncBookletWizard = asyncComponent(() =>
  import('./components/booklet-wizard/booklet-wizard')
);
const AsyncUsers = asyncComponent(() => import('./components/users/users'));
const AsyncUser = asyncComponent(() =>
  import('./components/user-form/user-form')
);
const AsyncActorsList = asyncComponent(() =>
  import('./components/actor-list/actor-list')
);
const AsyncActor = asyncComponent(() => import('./components/actor/actor'));

const AsyncLocationList = asyncComponent(() =>
  import('./components/location-list/location-list')
);
const AsyncLocation = asyncComponent(() =>
  import('./components/location/location')
);
const AsyncCreatorList = asyncComponent(() =>
  import('./components/creator-list/creator-list')
);
const AsyncCreator = asyncComponent(() =>
  import('./components/creator/creator')
);
const AsyncLogout = asyncComponent(() => import('./components/logout/logout'));
const AsyncMediaHub = asyncComponent(() =>
  import('./components/media-hub/main/main')
);

const mapStateToProps = state => ({
  token: state.auth.token,
  error: state.auth.error,
});

export default connect(mapStateToProps)(props => {
  const { history, dispatch } = props;

  history.listen(root => {
    if (!root.pathname.includes('/booklet/')) {
      dispatch(setLazyLoading(false));
    }
  });

  return (
    <ConnectedRouter history={history}>
      <Switch>
        <AuthenticatedRoute
          path="/"
          exact
          component={AsyncBookletList}
          props={{ ...props, action: fetchBookletList }}
        />
        <AuthenticatedRoute
          path="/archive"
          exact
          component={AsyncBookletArchive}
          props={{ ...props, action: fetchBookletArchive }}
        />
        <AuthenticatedRoute
          path="/booklet/new"
          exact
          component={AsyncBookletWizard}
          adminOnly
          props={{ ...props, action: createEmptyBooklet }}
        />
        <AuthenticatedRoute
          path="/booklet/:id"
          exact
          component={AsyncBooklet}
          props={{ ...props, action: fetchBooklet }}
        />
        <AuthenticatedRoute
          path="/booklet/:id/timeline"
          exact
          component={AsyncBooklet}
          props={{ ...props, action: fetchBooklet }}
        />
        <Route
          path="/shared/:id"
          exact
          render={props => (
            <AsyncBookletShared
              {...props}
              history={history}
              action={fetchBookletShared}
            />
          )}
        />
        <AuthenticatedRoute
          path="/talents"
          exact
          component={AsyncActorsList}
          props={{ ...props, action: fetchFolders }}
        />
        <AuthenticatedRoute
          path="/talents/new"
          exact
          component={AsyncActor}
          adminOnly
          props={{ ...props, action: createEmptyExtension }}
        />
        <AuthenticatedRoute
          path="/talents/:id"
          exact
          component={AsyncActor}
          props={{ ...props, action: fetchExtension }}
        />
        <AuthenticatedRoute
          path="/locations"
          exact
          component={AsyncLocationList}
          props={{ ...props, action: fetchFolders }}
        />
        <AuthenticatedRoute
          path="/locations/new"
          exact
          component={AsyncLocation}
          adminOnly
          props={{ ...props, action: createEmptyExtension }}
        />
        <AuthenticatedRoute
          path="/locations/:id"
          exact
          component={AsyncLocation}
          props={{ ...props, action: fetchExtension }}
        />
        <AuthenticatedRoute
          path="/creators"
          exact
          component={AsyncCreatorList}
          props={{ ...props, action: fetchFolders }}
        />
        <AuthenticatedRoute
          path="/creators/new"
          exact
          component={AsyncCreator}
          adminOnly
          props={{ ...props, action: createEmptyExtension }}
        />
        <AuthenticatedRoute
          path="/creators/:id"
          exact
          component={AsyncCreator}
          props={{ ...props, action: fetchExtension }}
        />
        <AuthenticatedRoute
          path="/users"
          exact
          component={AsyncUsers}
          adminOnly
          props={{ ...props, action: fetchUsers }}
        />
        <AuthenticatedRoute
          path="/users/new"
          exact
          component={AsyncUser}
          adminOnly
          props={{ ...props, action: createEmptyUser }}
        />
        <AuthenticatedRoute
          path="/users/:id"
          exact
          component={AsyncUser}
          adminOnly
          props={{ ...props, action: fetchUser }}
        />
        <Route
          path="/decks/shared"
          render={props => <AsyncMediaHub {...props} shared={true} />}
        />
        <AuthenticatedRoute
          path="/decks"
          component={AsyncMediaHub}
          props={props}
        />
        <Route exact path="/logout" component={AsyncLogout} props={props} />
        <Route render={() => <Redirect to="/404" />} />
      </Switch>
    </ConnectedRouter>
  );
});



// WEBPACK FOOTER //
// ./src/routes.js